import { Organization } from '../../organizations';
import updateActivityModalTemplate from './update-activity-modal.html';
class UpdateActivityModalController {
  static $inject = ['Organization'];

  modalInstance: any;
  activity: any;
  organizations: Organization[] = [];
  members: any[] = [];

  constructor(private Organization) { }

  membersFiltered() {
    return [];
  }

  $onInit() {
    if (!this.activity.members) {
      this.activity.members = [];
    }

    this.Organization.getMembers(this.activity.organization.shortName).then(
      (orgMembers) => {
        this.members = orgMembers.map((orgMember) => {
          const member = orgMember.member;
          //TODO : fix this on backend. Organizations should not be serialized
          delete member.organizations;
          return member;
        });
      },
    );
  }

  ok() {
    this.modalInstance.close(this.activity);
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }
}

export const UpdateActivityModalComponent = {
  template: updateActivityModalTemplate,
  bindings: {
    modalInstance: '<',
    activity: '<',
    organizations: '<',
  },
  controller: UpdateActivityModalController,
};
